<main class="p-4 container-lg">
  <h2 class="mb-3">Manage User Profile</h2>
  <div class="row">
    <div class="col-12 col-lg-6">
      <div class="card mb-3">
        <div class="card-body">
          <h3 class="mb-3">User/Password</h3>

          <p class="mb-4">Email Address: <strong>{{email}}</strong></p>


          <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()">
            <h5>Change Password</h5>

            <div class="from-group mb-3">
              <label for="currentPassword" class="form-label">Current password</label>
              <input type="password" class="form-control" formControlName="currentPassword" />
              <div class="text-danger" *ngIf="changePasswordFormControl.currentPassword.touched && changePasswordFormControl.currentPassword.errors?.required">
                Current password is required
              </div>
            </div>
            <div class="form-group mb-3">
              <label for="newPassword" class="form-label">New password</label>
              <input type="password" class="form-control" formControlName="newPassword" />
              <div class="text-danger" *ngIf="changePasswordFormControl.newPassword.touched && changePasswordFormControl.newPassword.errors?.required">
                New password is required
              </div>
            </div>
            <div class="form-group mb-3">
              <label for="confirmNewPassword" class="form-label">Confirm new password</label>
              <input type="password" class="form-control" formControlName="confirmNewPassword" />
              <div class="text-danger" *ngIf="changePasswordFormControl.newPassword.touched && changePasswordFormControl.confirmNewPassword.touched && changePasswordForm.errors?.PasswordNoMatch">
                Passwords do not match.
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <button type="submit" class="btn btn-primary mt-3">
                <i class="fa-solid fa-lock" [class]="{'fa-lock': !changingPassword, 'fa-spinner': changingPassword, 'fa-spin': changingPassword}"></i> Change Password
              </button>
            </div>
            <div class="alert alert-success mt-3" *ngIf="passwordChangeSuccess">
              Password changed successuflly!
            </div>
            <div class="alert alert-danger mt-3" *ngIf="passwordChangeFailed">
              Unable to change password. {{passwordChangeFailedDetail}}
            </div>
          </form>
        </div>
      </div>


      <div class="card mb-3">
        <div class="card-body">
          <h3 class="mb-3">Email Communication</h3>
          <p>
            We occasionlly send out emails with discounts and announcements. If you do not want to receive
            emails, uncheck the option below.
          </p>
          <input class="form-check-input me-1" type="checkbox" id="emailOptIn" [(ngModel)]="emailOptIn" (ngModelChange)="updateEmailOptIn()">
          <label class="form-check-label" for="emailOptIn">
            Yes, send me emails about discounts and updates
          </label>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-6">
      <div class="card">
        <div class="card-body">
          <h3 class="mb-4">Payment/Subscription</h3>
          <h5>Subscription Information</h5>
          <p>
            Level: <strong>{{subscription?.subscriptionLevel}}</strong>
          </p>
          <p>
            AI Engineer:
            @if(subscription?.aiEngineerSubscriptionExpiration == null){
            <strong>Not Subscribed</strong>
            }
            @else{
            <strong>Expires {{subscription?.aiEngineerSubscriptionExpiration | date:'longDate'}}</strong>
            <button type="button" class="btn btn-sm btn-outline-danger ms-2" (click)="cancelSubscription()" *ngIf="!subscription.isAIEngineerSubscriptionCancelled">Cancel</button>
            <span *ngIf="subscription.isAIEngineerSubscriptionCancelled"> (Canceled)</span>
            }
          </p>
          @if(subscription?.aiEngineerSubscriptionExpiration != null && !subscription?.isAIEngineerSubscriptionCancelled){
          <h5>Billing Portal</h5>
          <p>
            Recurring payments for GT Pro Tune AI Engineer is handled by Stripe. To update your payment method or view past invoices, visit the Billing Portal.
          </p>
          <p>
            <button type="button" class="btn btn-primary btn-sm" (click)="openBillingPortal()">Open Billing Portal <sup><i class="fa-solid fa-arrow-up-right-from-square"></i></sup></button>
          </p>
          }
          @if(subscription?.subscriptionLevel == 'Trial' || subscription?.subscriptionLevel == 'Lite' || !hasAIEngineerSubscription){
          <p>
            <a routerLink="/subscription">Upgrade Subscription</a>
          </p>
          }
        </div>
      </div>
    </div>
  </div>
</main>
